import script from "./MDataTableRow.vue?vue&type=script&setup=true&lang=js"
export * from "./MDataTableRow.vue?vue&type=script&setup=true&lang=js"

import "./MDataTableRow.vue?vue&type=style&index=0&id=5191d9eb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5191d9eb"]])

export default __exports__